import * as React from "react";
const useVariantSwitcher = ({
  variants,
  initialSku
}) => {
  const [activeSku, setActiveSku] = React.useState(initialSku);
  const activeVariant = variants.find((variant) => variant.sku === activeSku);
  const handleVariantChange = (sku) => {
    if (sku) {
      setActiveSku(sku);
    }
  };
  const facetTerms = [];
  const consolidatedVariants = variants.reduce((acc, variant) => {
    if (!variant.consolidationFacet) {
      return [...acc, variant];
    }
    if (facetTerms.includes(variant.consolidationFacet)) {
      return acc;
    }
    facetTerms.push(variant.consolidationFacet);
    return [...acc, variant];
  }, []);
  return {
    activeSku,
    activeVariant,
    handleVariantChange,
    consolidatedVariants
  };
};
export {
  useVariantSwitcher
};
//# sourceMappingURL=use-variant-switcher.js.map
